import { Box, ColorOptions, convertHexToRGBA, Icon, TextInput } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useWindowDimensions } from 'react-native'
import { Colors } from '../../util/util'

export const SearchBar = ({ onSearchPress, searchString, setSearchString }) => {
  const { width } = useWindowDimensions()

  const searchIcon = () => {
    return (
      <Box
        w={32}
        h={32}
        justify={'center'}
        align={'center'}
        underlayColor="LIGHTEST_GREY"
        testID="search-txn"
        onPress={() => onSearchPress(searchString)}>
        <Icon id="SEARCH" color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions} size={20} />
      </Box>
    )
  }

  const updateText = (textEntered: string) => {
    //onSearchPress(textEntered)
    setSearchString(textEntered)
  }

  const rightComp = () => {
    if (isEmpty(searchString)) {
      return null
    }
    return searchIcon()
  }

  const onKeyPress = ({ nativeEvent: { key: keyValue } }) => {
    if (keyValue === 'Enter') {
      onSearchPress(searchString)
    }
  }

  return (
    <Box bg={'WHITE'} ph={24}>
      <Box
        flexDirection="row"
        width={width - 48}
        borderWidth={1}
        h={48}
        align={'center'}
        borderRadius={8}
        pl={8}
        pr={6}
        borderColor={Colors.BLACK_14 as ColorOptions}>
        <Box f={1} pl={12}>
          <TextInput
            value={searchString}
            fontSize={16}
            placeholder={'Search Transactions'}
            onFocusBottomLineColor="TRANSPARENT"
            autoCorrect={false}
            placeholderTextColor={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
            fontFamily={'SourceSans3-Medium'}
            fontWeight={'500'}
            lineHeight={24}
            autoFocus={true}
            selectionColor={Colors.BLACK_14 as ColorOptions}
            onChangeText={(textEntered: string) => {
              updateText(textEntered)
            }}
            rightComponent={rightComp()}
            onKeyPress={onKeyPress}
          />
        </Box>
      </Box>
    </Box>
  )
}
